function empty() {
  return [];
}

export default function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selectorAll.js
// module id = 160
// module chunks = 0 1 2 3 4